export default __webpack_public_path__ + "static/media/0xbbba073c31bf03b8acf7c28ef0738decf3695683.a9e47d46.webp";